import { formatValue, tooltipFormatterAxis } from "./common-energia";
const COLOR_CONSUMIDA = '#87D3F8';
const COLOR_VERTIDA = '#ACE1AF';

export const GAUGE_CHART_OPTIONS = {
  grid: {
    left: '0',
    right: '0',
    bottom: '0',
    top: '50',
    containLabel: true,
  },
  title: {
    margin: 0,
    padding: 0,
    top: '10',
    left: '50%',
    textAlign: 'center',
    itemGap: 0,
    textStyle: {
      fontSize: 15,
      lineHeight: 15,
      fontFamily: 'Montserrat',
      fontWeight: '500',
      color: '#666',
    },
    subtextStyle: {
      fontFamily: 'Montserrat',
      fontSize: 12,
      lineHeight: 12,
      fontWeight: 500,
      color: '#666',
      width: '100%',
    },
  },
  legend: {
    show: false,
  },
  toolbox: {
    show: true,
    right: '0',
    top: '5',
    emphasis: {
      iconStyle: {
        borderColor: '#ffcd00',
      },
    },
    feature: {
      saveAsImage: {
        title: 'Descargar',
      },
    },
    showTitle: false,
    tooltip: {
      show: true,
      padding: [5, 8],
      position: 'left',
      formatter: function (param) {
        return '<div>' + param.title + '</div>';
      },
      backgroundColor: '#fff',
      textStyle: {
        fontSize: 11,
        fontFamily: 'Montserrat',
        fontWeight: 600,
      },
      extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);border-radius: 0;',
    },
  },
  tooltip: {
    show: true,
    trigger: 'none',
  },
  series: [
    {
      type: 'gauge',
      silent: true,
      center: ['50%', '75%'],
      radius: '75%',
      startAngle: 200,
      endAngle: -20,
      min: 0,
      progress: {
        show: true,
        width: 20,
        itemStyle: {
          color: '#87D3F8', // pale azzure consumida
        },
      },
      pointer: {
        show: false,
      },
      axisLine: {
        lineStyle: {
          width: 20,
        },
      },
      axisTick: {
        distance: -25,
        splitNumber: 5,
        length: 3,
        lineStyle: {
          width: 1,
          color: '#ccc',
        },
      },
      splitLine: {
        distance: -28,
        length: 2,
        lineStyle: {
          width: 1,
          color: '#ccc',
        },
      },
      axisLabel: {
        distance: 6,
        fontSize: 10,
        fontWeight: '400',
        fontFamily: 'Montserrat',
        color: '#666',
      },
      anchor: {
        show: false,
      },
      detail: {
        width: '50%',
        borderRadius: 0,
        offsetCenter: [0, 0],
        valueAnimation: true,
        textStyle: {
          color: '#284B63', // marino palido
          fontStyle: 'normal',
          fontWeight: '600',
          fontFamily: 'Montserrat',
          fontSize: 18,
          lineHeight: 18,
        },
      },
      data: [
        {
          value: null,
        },
      ],
    },
  ],
  media: [
    {
      query: {
        minWidth: 280,
        minHeight: 230,
      },
      option: {
        series: [
          {
            center: ['50%', '77%'],
          },
        ],
      },
    },
    {
      query: {
        minWidth: 420,
      },
      option: {
        series: [
          {
            center: ['50%', '75%'],
            radius: '90%',
          },
        ],
      },
    },
    {
      query: {
        minWidth: 340,
      },
      option: {
        series: [
          {
            center: ['50%', '77%'],
            radius: '85%',
            progress: {
              width: 30,
            },
            axisLine: {
              lineStyle: {
                width: 30,
              },
            },
            axisTick: {
              distance: -40,
              length: 5,
              lineStyle: {
                width: 2,
              },
            },
            splitLine: {
              distance: -45,
              length: 10,
              lineStyle: {
                width: 2,
              },
            },
            axisLabel: {
              distance: 2,
              fontSize: 13,
            },
          },
        ],
      },
    },
    {
      // valor minWidth: 280 minHeight: 230,
      query: {
        minWidth: 280,
        minHeight: 230,
      },
      option: {
        series: [
          {
            detail: {
              fontSize: 22,
              lineHeight: 22,
            },
          },
        ],
      },
    },
    {
      // valor minWidth: 385 minHeight: 230,
      query: {
        minWidth: 385,
        minHeight: 230,
      },
      option: {
        series: [
          {
            detail: {
              fontSize: 24,
              lineHeight: 24,
            },
          },
        ],
      },
    },
    {
      // valor peq minWidth: 420 maxWidth: 450,
      query: {
        minWidth: 460,
      },
      option: {
        series: [
          {
            detail: {
              fontSize: 30,
              lineHeight: 30,
            },
          },
        ],
      },
    },
    {
      // title móvil
      query: {
        minWidth: 280,
        minHeight: 230,
        maxWidth: 305,
        maxHeight: 302,
      },
      option: {
        title: {
          top: '5',
          itemGap: 3,
          textStyle: {
            fontSize: 13,
          },
          subtextStyle: {
            fontSize: 10,
          },
        },
      },
    },
  ],
};

export const CHART_BAR_OPTIONS = {
  grid: {
    left: '0',
    right: '0',
    bottom: '0',
    top: '65',
    containLabel: true,
  },
  title: {
    text: '',
    show: true,
    top: '0',
    left: '50%',
    textAlign: 'center',
    textStyle: {
      fontSize: 15,
      fontFamily: 'Montserrat',
      fontWeight: 500,
      color: '#666',
    },
  },
  toolbox: {
    show: true,
    right: '0',
    top: '0',
    feature: {
      saveAsImage: {
        title: 'Descargar',
      },
    },
    emphasis: {
      iconStyle: {
        borderColor: '#ffcd00',
      },
    },
    showTitle: false,
    tooltip: {
      show: true,
      padding: [5, 8],
      position: 'left',
      formatter: function (param) {
        return '<div>' + param.title + '</div>';
      },
      backgroundColor: '#fff',
      textStyle: {
        fontSize: 11,
        fontFamily: 'Montserrat',
        fontWeight: 600,
      },
      extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);border-radius: 0;',
    },
  },
  legend: {
    show: false,
  },
  tooltip: {
    trigger: 'axis',
    show: true,
    confine: true,
    axisPointer: {
      type: 'none',
    },
    formatter: tooltipFormatterAxis,
    textStyle: {
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: 500,
    },
  },
  xAxis: {
    data: [],
    show: true,
    type: 'category',
    axisTick: { show: false },
    boundaryGap: ['20%', '20%'],
    gridIndex: 0,
    offset: 0,
    axisLine: {
      lineStyle: {
        color: '#ddd',
      },
    },
    axisLabel: {
      show: true,
      interval: 'auto',
      textStyle: {
        fontFamily: 'Montserrat',
        fontSize: 10,
        color: '#333',
      },
      formatter: (value) => value,
    },
  },
  graphic: [
    {
      id: 'circleConsumida',
      type: 'circle',
      left: 0,
      top: 36,
      shape: {
        cx: 0,
        cy: 0,
        r: 7,
      },
      style: {
        fill: COLOR_CONSUMIDA,
      },
    },
    {
      id: 'textConsumida',
      type: 'text',
      left: 20,
      top: 36,
      style: {
        text: 'Consumida',
        fontSize: 12,
        fontFamily: 'Montserrat',
        fontWeight: 600,
        fill: '#666',
      },
    },
    {
      id: 'circleVertida',
      type: 'circle',
      right: 0,
      top: 35,
      shape: {
        cx: 0,
        cy: 0,
        r: 7,
      },
      style: {
        fill: COLOR_VERTIDA,
      },
    },
    {
      id: 'textVertida',
      type: 'text',
      right: 20,
      top: 35,
      style: {
        text: 'Vertida',
        fontSize: 12,
        fontFamily: 'Montserrat',
        fontWeight: 600,
        fill: '#666',
      },
    },
  ],
  yAxis: [
    {
      type: 'value',
      position: 'left',
      alignTicks: true,
      min: 0,
      /*
      name: 'Consumida',
      nameTextStyle: {
        align: 'right',
        width: 60,
        fontSize: 14,
        fontFamily: 'Montserrat',
        fontWeight: 600,
        padding: [0, -55, 0, 0],
        margin: 0,
      },
      */
      axisLabel: {
        formatter: formatValue,
        showMinLabel: false,
        margin: 10,
        width: 60,
        textStyle: {
          fontSize: 10,
          fontFamily: 'Montserrat',
          fontWeight: 400,
          color: '#333',
        },
      },
      axisLine: {
        lineStyle: {
          width: 2,
        },
      },
    },
    {
      type: 'value',
      position: 'right',
      alignTicks: true,
      min: 0,
      /*
      name: 'Vertida',
      nameTextStyle: {
        align: 'right',
        fontSize: 14,
        fontFamily: 'Montserrat',
        fontWeight: 600,
        padding: [0, -30, 0, 0],
        margin: 0,
      },
      */
      axisLabel: {
        formatter: formatValue,
        showMinLabel: false,
        width: 60,
        textStyle: {
          fontSize: 10,
          fontFamily: 'Montserrat',
          fontWeight: 400,
          color: '#333',
        },
      },
      axisLine: {
        lineStyle: {
          width: 2,
        },
      },
    },
  ],
  series: [
    {
      name: 'Energía Consumida',
      data: [],
      type: 'bar',
      barWidth: 'auto',
      barMinWidth: 3,
      barMaxWidth: 8,
      color: COLOR_CONSUMIDA,
      yAxisIndex: 0,
    },
    {
      name: 'Energía Vertida',
      data: [],
      type: 'bar',
      barWidth: 'auto',
      barMinWidth: 3,
      barMaxWidth: 8,
      color: COLOR_VERTIDA,
      yAxisIndex: 1,
    },
  ],
  media: [
    {
      // móvil
      query: {
        maxWidth: 480,
      },
      option: {
        grid: {
          top: '80',
        },
        title: {
          textStyle: {
            fontSize: 13,
            lineheight: 15,
            width: 200,
            overflow: 'break',
          },
        },
        graphic: [
          {
            id: 'circleConsumida',
            top: 52,
            left: 0,
            shape: {
              cx: 0,
              cy: 0,
              r: 7,
            },
            style: {
              fill: COLOR_CONSUMIDA,
            },
          },
          {
            id: 'textConsumida',
            top: 55,
            left: 20,
            style: {
              text: 'Consumida',
              fontSize: 10,
              fontFamily: 'Montserrat',
              fontWeight: 600,
              fill: '#666',
            },
          },
          {
            id: 'circleVertida',
            top: 52,
            right: 0,
            shape: {
              cx: 0,
              cy: 0,
              r: 7,
            },
            style: {
              fill: COLOR_VERTIDA,
            },
          },
          {
            id: 'textVertida',
            top: 55,
            right: 20,
            style: {
              text: 'Vertida',
              fontSize: 10,
              fontFamily: 'Montserrat',
              fontWeight: 600,
              fill: '#666',
            },
          },
        ],
        yAxis: [
          {
            axisLabel: {
              margin: 3,
              width: 60,
              textStyle: {
                fontSize: 7,
              },
            },
            axisLine: {
              lineStyle: {
                width: 2,
              },
            },
          },
          {
            axisLabel: {
              margin: 3,
              width: 60,
              textStyle: {
                fontSize: 7,
              },
            },
            axisLine: {
              lineStyle: {
                width: 2,
              },
            },
          },
        ],
      },
    },
    {
      //barWidth peq
      query: {
        minWidth: 760,
      },
      option: {
        series: [
          {
            barMinWidth: 10,
            barMaxWidth: 16,
            yAxisIndex: 0,
          },
          {
            barMinWidth: 10,
            barMaxWidth: 16,
            yAxisIndex: 1,
          },
        ],
      },
    },
    {
      //barWidth big
      query: {
        minWidth: 1125,
      },
      option: {
        series: [
          {
            barMinWidth: 10,
            barMaxWidth: 16,
            yAxisIndex: 0,
          },
          {
            barMinWidth: 10,
            barMaxWidth: 16,
            yAxisIndex: 1,
          },
        ],
      },
    },
  ],
};